export default {
  cognito: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    appClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  },
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
};
